import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Heart, Sparkles } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Sparkles,
      title: 'Detail-Oriented',
      description: 'Meticulous attention to every corner, edge, and surface'
    },
    {
      icon: Shield,
      title: 'Fully Insured',
      description: 'Complete protection and peace of mind for every service'
    },
    {
      icon: Award,
      title: 'Trusted in Georgia',
      description: 'Serving businesses and families with excellence since 2024'
    },
    {
      icon: Heart,
      title: 'Customer First',
      description: 'Creating comfort, safety, and satisfaction in every corner'
    }
  ];

  return (
    <section id="about" className="py-32" style={{ background: '#FDFDFC' }}>
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span
              className="text-xs font-bold tracking-[0.2em] uppercase mb-4 inline-block"
              style={{ color: '#0284C7' }}
            >
              ABOUT US
            </span>
            <h2
              className="text-3xl sm:text-4xl tracking-tight font-medium mb-6"
              style={{ fontFamily: 'Outfit', color: '#0F172A' }}
            >
              Radius Cleaning Company LLC
            </h2>
            <p className="text-base leading-relaxed mb-8" style={{ color: '#475569' }}>
              Where your space gets the royal treatment! Specializing in commercial and post-construction 
              cleaning, standard and deep cleaning, plus unique add-ons. Fully insured and 
              trusted by Georgia's businesses and families since 2024.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{ color: '#475569' }}>
              We're not just cleaning; we're creating comfort, safety, and satisfaction in every corner. 
              Our dedicated team brings attention to detail and care that sets us apart.
            </p>

            <div className="grid grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex flex-col"
                  data-testid={`feature-${index}`}
                >
                  <feature.icon className="w-10 h-10 mb-3" style={{ color: '#0284C7' }} />
                  <h4 className="text-lg font-medium mb-2" style={{ color: '#0F172A' }}>
                    {feature.title}
                  </h4>
                  <p className="text-sm leading-relaxed" style={{ color: '#475569' }}>
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid #E2E8F0' }}>
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?fm=jpg&q=80&w=1200&auto=format&fit=crop"
                alt="Clean, modern office space"
                className="w-full h-full object-cover"
                style={{ minHeight: '500px' }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;